export class SequenceNumber {
    minValue;
    maxValue;
    value;
    constructor(initialValue = 0, minValue, maxValue) {
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.value = initialValue;
    }
    validate(other) {
        if (other < this.minValue) {
            throw new Error(`Invalid sequence number: ${other} < 0`);
        }
        if (other > this.maxValue) {
            throw new Error(`Invalid sequence number: ${other} > ${this.maxValue}`);
        }
    }
    get() {
        return this.value;
    }
    set(value) {
        this.validate(value);
        this.value = value;
    }
    increment(by = 1) {
        if (by < 0) {
            throw new Error('Cannot decrement the sequence number');
        }
        const value = this.value;
        this.set(value + by);
        return value;
    }
}
